module.exports = __webpack_public_path__ + "img/exploreMockup.6e3ed54e.png";